module.exports = __webpack_public_path__ + "img/suburbs.f98482ca.svg";